const placeholder = document.querySelector('.video-placeholder');
const playButton = document.querySelector('.play-button');
const loader = document.querySelector('#loader');

if(playButton) {
    playButton.addEventListener('click', function() {
        const js = document.createElement("script");
        js.src = '../wp-content/themes/rvon/js/vimeo.js';
        js.id = "vimeo-script";
        document.body.appendChild(js);
        playButton.style.display = 'none';
        loader.style.display = 'block';

        js.onload = function() {
            const videoID = rvo_obj_vimeo.vimeo_id;
            const options = {
                id: videoID,
            };

            const player = new Vimeo.Player('video-container', options);
            player.ready().then(function() {
                loader.style.display = 'none';
                placeholder.style.display = 'none';
                player.play();
            });
        };
    });
}
